import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CookieService, FundraiserService } from '../../../shared/services';

@Component({
  selector: 'app-private-fundraiser',
  templateUrl: './private-fundraiser.component.html',
  styleUrls: ['./private-fundraiser.component.scss']
})
export class PrivateFundraiserComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PrivateFundraiserComponent>,
    private router: Router,
    private fb: FormBuilder,
    public fundraiserService: FundraiserService,
    private cookieService: CookieService,
  ) { }

  pinForm: FormGroup;
  showCaptcha = false;
  captchaSubs: Subscription;
  pinValue = '';
  @ViewChild('captchaRef') captchaRef;
  isRequiredError = false;
  isPatternError = false;
  isLoading = false;
  disableSubmitBtn = false;

  ngOnInit() {
    this.initForm();
  }

  initForm(): void {
    this.pinForm = this.fb.group({
      pin: this.fb.group({
        pinDigit1: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
        pinDigit2: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
        pinDigit3: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
        pinDigit4: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
        pinDigit5: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
        pinDigit6: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      }, [Validators.required, Validators.pattern(/^[a-z0-9]+$/)]),
      captcha: ['', Validators.required]
    });
  }

  changeInput(prevInpRef, currentInpRef, nextInpRef, event): void {
    if (prevInpRef && event.which === 8) {
      prevInpRef.focus();
    } else {
      if (currentInpRef && currentInpRef.value.length === 1 && nextInpRef) {
        nextInpRef.focus();
      }
    }
    this.checkErrors();
  }

  toggleCaptcha() {
    if (this.captchaRef) {
      this.captchaRef.resetCaptcha();
      this.pinForm.get('captcha').setValue('');
    }
  }

  captchaResolve() {
    this.captchaSubs = this.captchaRef.captchaResolvedObs.subscribe({
      next: (data) => {
        if (data !== null && data !== '' && this.pinForm.valid) {
          this.disableSubmitBtn = false;
          this.validatePin();
        } else {
          this.isLoading = false;
          this.pinForm.markAllAsTouched();
          this.isRequiredError = true;
          this.disableSubmitBtn = true;
        }
      }
    });
  }

  formSubmit(): void {
    this.showCaptcha = true;
    this.isLoading = true;
    setTimeout(() => {
      this.captchaResolve();
    }, 200);
  }

  checkErrors(): void {
    [1, 2, 3, 4, 5, 6].forEach(index => {
      const control = this.pinForm.get(`pin.pinDigit${index}`);
      if (control.touched && control.invalid) {
        this.disableSubmitBtn = true;
        if (control.errors && control.errors.required) {
          this.isRequiredError = true;
          return;
        } else if (control.errors && control.errors.pattern) {
          this.isPatternError = true;
          return;
        }
      } else if (control.touched && control.valid) {
        this.isPatternError = false;
        this.isRequiredError = false;
      }
    });
    if (this.pinForm.get('pin').valid) {
      this.disableSubmitBtn = false;
    }
  }

  validatePin() {
    this.pinValue = '';
    for (const key in this.pinForm.get('pin').value) {
      if (Object.prototype.hasOwnProperty.call(this.pinForm.get('pin').value, key)) {
        const element = this.pinForm.get('pin').value[key];
        this.pinValue = this.pinValue + element;
      }
    }
    if (this.pinForm.valid) {
      this.fundraiserService.verifyPrivateFundraiserPIN(this.data.campaignId, this.pinValue)
        .subscribe((responseData: any) => {
          this.isLoading = false;
          this.showCaptcha = false;
          if (responseData.data) {
            this.dialogRef.close(responseData);
            const domain = environment.name === 'local' ? 'localhost' : '.ketto.org';
            this.cookieService.setCookie(`privateFundPinAllowed-${this.data.customTag}`, this.data.customTag, 30, domain);
            this.pinForm.get('pin').reset();
            this.toggleCaptcha();
          }
        }, error => {
          this.isLoading = false;
          this.pinForm.get('pin').reset();
          this.toggleCaptcha();
          this.showCaptcha = false;
        });
    } else {
      this.disableSubmitBtn = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
    this.router.navigate(['/']);
  }

}
